import { render } from "./HeroAuthNav.vue?vue&type=template&id=27cad69e&scoped=true"
import script from "./HeroAuthNav.vue?vue&type=script&lang=js"
export * from "./HeroAuthNav.vue?vue&type=script&lang=js"

import "./HeroAuthNav.vue?vue&type=style&index=0&id=27cad69e&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cad69e"]])

export default __exports__